/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AdditionalResourceDetailsForFinopsUnderUtilizedAwsComputeOptimizer extends models.AdditionalResourceDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("AdditionalResourceDetailsForFinopsUnderUtilizedAwsComputeOptimizer");
    }

    getFixupPrototypeFunction() { return AdditionalResourceDetailsForFinopsUnderUtilizedAwsComputeOptimizer.fixupPrototype; }

    static newInstance(model: Partial<AdditionalResourceDetailsForFinopsUnderUtilizedAwsComputeOptimizer>): AdditionalResourceDetailsForFinopsUnderUtilizedAwsComputeOptimizer {
        let obj = Object.assign(new AdditionalResourceDetailsForFinopsUnderUtilizedAwsComputeOptimizer(), model);
        AdditionalResourceDetailsForFinopsUnderUtilizedAwsComputeOptimizer.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AdditionalResourceDetailsForFinopsUnderUtilizedAwsComputeOptimizer>): AdditionalResourceDetailsForFinopsUnderUtilizedAwsComputeOptimizer {
        if (!model) return null;
        return AdditionalResourceDetailsForFinopsUnderUtilizedAwsComputeOptimizer.newInstance(<AdditionalResourceDetailsForFinopsUnderUtilizedAwsComputeOptimizer> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AdditionalResourceDetailsForFinopsUnderUtilizedAwsComputeOptimizer) {
        if (!obj) return;

        models.AdditionalResourceDetailsForFinopsUnderUtilizedAwsComputeOptimizer.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AdditionalResourceDetailsForFinopsUnderUtilizedAwsComputeOptimizer): boolean {
        if (models.AdditionalResourceDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AdditionalResourceDetailsForFinopsUnderUtilizedAwsComputeOptimizer.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
